
export class StreamPlugin {
  
  

}